export default "__VITE_ASSET__009f19ac__"